import React from 'react';
import { Theme, ListItem, Typography, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { IReduxState, AccessLevel } from '../../types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EditMachineNote from './EditMachineNote';
import EditMachineConstructionSite from './EditMachineConstructionSite';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    zIndex: 1,
    flexGrow: 1,
  },
  card: {
    [theme.breakpoints.up('xs')]: {
      margin: `${theme.spacing(4)}px 0`,
    },
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
      height: 400,
    },
  },
  cardContent: {
    height: '100%',
  },
  actionsArena: {
    paddingTop: 0,
    paddingBottom: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  list: {
    height: '100%',
    overflowY: 'auto',
    width: '100%',
  },
  tagsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  title: {
    display: 'flex',
    // flexDirection: 'row',
    // justifyItems: 'space-around',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  constructionSite: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  longText: {
    // whiteSpace: 'pre-line',
    // wordBreak: 'break-word',
    // padding: '8px 0',
    // overflowX: 'auto',     
    // overflowY: 'hidden',
    // display: 'block',
    // maxWidth: '100%',
    // maxHeight: 90,
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
    padding: '8px 0',
    maxWidth: '100%',

    // Vertikaler Scrollbar nur wenn n�tig
    maxHeight: 50,                    // ca. 2 Zeilen � gut lesbar
    overflowY: 'auto',                 // ? Vertikaler Scroll
    overflowX: 'auto',               // Kein horizontaler Scroll

    // Sch�ner Scrollbar (Chrome, Edge, Safari)
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      // borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.grey[500],
      },
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    // F�r Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.grey[400]} transparent`,  },
}));

export default function MachineNotes() {
  const classes = useStyles();
  const { t } = useTranslation();
  const machineNote = useSelector(
    (state: IReduxState) => state.machineDetails.machine.notes
  );
  const projectConstructionSite = useSelector(
    (state: IReduxState) => state.machineDetails.machine.projectConstructionSite
  );
  
  const currentlyAuthenticatedUserAccessLevel = useSelector(
    (state: IReduxState) =>
      state.machineDetails.machine.currentlyAuthenticatedUserAccessLevel
  );
  return (
    <React.Fragment>
      <ListItem dense alignItems="flex-start">
        <div className={classes.title}>
          <Typography gutterBottom variant="h6">
            {t('machine.notes')}
          </Typography>
          {currentlyAuthenticatedUserAccessLevel === AccessLevel.Write && (
            <EditMachineNote />
          )}
        </div>
      </ListItem>
      {machineNote ? (
        <ListItem dense alignItems="flex-start">
          <ListItemText
            secondary={
              <Typography
                variant="body1"
                color="textSecondary"
                component="div"
                className={classes.longText}
              >
                {machineNote}
              </Typography>
            }
          />
        </ListItem>
      ) : (
        <ListItem dense alignItems="flex-start">
          <ListItemText
            secondary={
              <Typography
                variant="subtitle1"
                color="textSecondary"
                component="span"
              >
                {t('machine.noNotes')}
              </Typography>
            }
          />
        </ListItem>
      )}
      {/* Baustelle */}
      {/* Construction Site Titel */}
      <ListItem dense alignItems="flex-start">
        <div className={classes.title}>
          <Typography gutterBottom variant="h6">
            {t('machine.constructionSite')}
          </Typography>
          {currentlyAuthenticatedUserAccessLevel === AccessLevel.Write && (
            <EditMachineConstructionSite />
          )}
        </div>
      </ListItem>

      {/* Construction Site Inhalt */}
      <ListItem dense alignItems="flex-start">
        <ListItemText
          secondary={
            <Typography
              variant="body1"
              color="textSecondary"
              component="div"
              className={classes.longText}
            >
              {currentlyAuthenticatedUserAccessLevel === AccessLevel.Write
                ? projectConstructionSite
                : t('accessLevel.placeholder')}
            </Typography>
          }
        />
      </ListItem>


      {/* <ListItem dense alignItems="flex-start">
        <div className={classes.title}>
          <ListItemText
            primary={t('machine.constructionSite')}
            secondary={
              <React.Fragment>
                <Typography
                  variant="body1"

                  color="textSecondary"
                  // component="span"
                  component="div"
                  className={classes.constructionSiteText}
                >
                  { 
                    //currentlyAuthenticatedUserAccessLevel === AccessLevel.Read ||
                    currentlyAuthenticatedUserAccessLevel === AccessLevel.Write
                    ? projectConstructionSite
                    : t('accessLevel.placeholder')}
                </Typography>
              </React.Fragment>
            }
          />
          {currentlyAuthenticatedUserAccessLevel ===
          AccessLevel.Write ? (
            <EditMachineConstructionSite />
          ) : null}
        </div>
      </ListItem> */}

    </React.Fragment>
  );
}
